import { ACTIONS } from 'src/app/core/utils/actions.constants';
import { COMMONS } from 'src/app/core/utils/commons.constants';

/**
 * @deprecated Use translation json file instead
 */
export const ODONTO_MODULE_CONSTANTS = {
  id: 'odonto.consult',
  title: 'Consulta',

  labels: {
    ...COMMONS,

    subject: {
      heading: 'Motivo de Consulta',
      help: 'Anotar la causa del problema en la versión del informante'
    },

    disease: {
      heading: 'Enfermedad o Problema Actual',
      help: 'Registrar síntomas: cronología, localización, características, intensidad, '
        + 'causa aparente, síntomas asociados, evolución, estado actual'
    },

    history: {
      heading: 'Antecedentes Personales y Familiares',
      help: 'Describir la patología de la región después de seleccionarla'
    },

    header: {
      heading: 'Signos Vitales',
      bloodPressure: 'Presión arterial',
      pulse: 'Frecuencia cardíaca',
      temperature: 'Temperatura C',
      breathingRate: 'Frecuencia respiratoria'
    },

    stomatognathic: {
      heading: 'Examen del Sistema Estomatognático',
      help: 'Describir la patología de la región después de seleccionarla'
    },

    odontogram: {
      heading: 'Odontograma',
      help: 'Pintar con AZUL para tratamiento realizado - ROJO para patología actual\nMovilidad y recesión: marcar X (1, 2 ó 3) si aplica',
      recession: 'Recesión',
      mobility: 'Movilidad',
      vestibular: 'Vestibular',
      lingual: 'Lingual',
      symbology: 'Simbología'
    },

    oralHealth: {
      heading: 'Indicadores de Salud Bucal',
      periodontalDisease: 'Enfermedad Periodontal',
      badOcclusion: 'Mal Oclusión',
      fluorosis: 'Fluorosis',
      none: 'Nada',
      low: 'Leve',
      mid: 'Moderada',
      high: 'Severa',
      level1: 'AngleI',
      level2: 'AngleII',
      level3: 'AngleIII',
      teeth: 'Piezas Dentales',
      plaque: 'Placa',
      calc: 'Cálculo',
      gingivitis: 'Gingivitis',
      totals: 'Totales'
    },

    oralHygiene: {
      heading: 'Índices CPO-ceo',
      total: 'Total'
    },

    diagnosticPlan: {
      heading: 'Planes de Diagnóstico, Terapéutico y Educacional',
      help: 'Describir la patología despues de seleccionarla'
    },

    diagnostic: {
      heading: 'Diagnóstico',
      help: 'PRE = Presuntivo; DEF = Definitivo',
      description: 'Descripción',
      cie: 'CIE',
      pre: 'PRE',
      def: 'DEF'
    },

    therapy: {
      heading: 'Tratamiento',
      diagnostic: 'Diagnósticos y Complicaciones',
      procedure: 'Procedimiento',
      prescription: 'Prescripciones',
      doctor: 'Doctor',
      sesion: 'Sesión',
      date: 'Fecha'
    },

    additionalInformation: {
      heading: 'Exámenes Complementarios',
      help: 'Información adicional de la consulta'
    }
  },

  actions: {
    ...ACTIONS,
    editPatient: 'Editar información del paciente',
    seeHistoryPdf: 'Ver Historia en PDF'
  },
};
